import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Tooltip } from "reactstrap";
import AuthContext from "../../Context/AuthContext";
import "../../../src/assets/css/home.css"; // your existing CSS
import { GetCartCount } from "../../api/cartService";

export default function Header() {
    const [isSubNavOpen, setIsSubNavOpen] = useState(false);
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const [tooltipOpen, setTooltipOpen] = useState(false); 
    const [cartCount, setCartCount] = useState(0);

    const { user, logout, loading } = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();

    const defaultLedgerId = "00000000-0000-0000-0000-000000000000";
    const isLoggedIn = user.LEDGER_ID !== defaultLedgerId;

    //CORRECT - Define useEffect at the top level, move fetchCartCount inside
    useEffect(() => {
        const fetchCartCount = async () => {
            if (isLoggedIn) {
                try {
                    const response = await GetCartCount();
                    //console.log("cart count", response);
                    if (response?.ROW?.[0]?.CARTCOUNT) {
                        setCartCount(response.ROW[0].CARTCOUNT);
                    }
                } catch (error) {
                    console.error("Error fetching cart count:", error);
                }
            }
        };

        fetchCartCount();
    }, [isLoggedIn]); // Make sure to include isLoggedIn in dependencies

    const toggleSubNav = () => setIsSubNavOpen(!isSubNavOpen);
    const closeSubNav = () => setIsSubNavOpen(false);
    const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

    if (loading) return null;

     const getNavItems = () => {
     const baseItems = [
         { to: "/about-us", label: "About" },
         { to: "/product-range", label: "Product Range" },
         { to: "/services", label: "Services" },
         { to: "/catalogs", label: "Catalogs" },
         { to: "/contact-us", label: "Contact Us" },
         { to: "/events", label: "Events" },
         { to: "/learn", label: "Learn" },
         ];


     // Add Bin Stock only if logged in
     if (isLoggedIn) {
         baseItems.splice(4, 0, { to: "/bin-stock", label: "Bin Stock" });
     }

     return baseItems;
 };

     const navItems = getNavItems();


    const handleLogout = () => {
        setShowLogoutModal(false);
        logout();
        navigate("/login");
    };

    return (
        <>
            <header className="fixed-top">
                <div className="info-bar">
                    <div className="info-bar-content">
                        <span>IIJS DELHI 2025 – 13th – 15th September</span>
                        <span>IIJS DELHI 2025 – 13th – 15th September</span>
                        <span>IIJS DELHI 2025 – 13th – 15th September</span>
                    </div>
                </div>

                <nav
                    className="navbar-layer-2 navbar navbar-expand-lg navbar-dark shadow-sm"
                    style={{ height: "80px" }}
                >
                    <div
                        className="container-fluid d-flex justify-content-center align-items-center"
                        style={{ height: "100%" }}
                    >
                        <Link className="navbar-brand position-absolute start-50" to="/">
                            <img src="/assets/images/Logo/Logo.png" alt="Logo" height="70" />
                        </Link>

                        <div
                            className="position-absolute end-0 d-flex align-items-center"
                            style={{ height: "100%", padding: "20px" }}
                        >
                            {isLoggedIn ? (
                                <div className="d-flex align-items-center gap-3">
                                    <Link
                                        to="/add-to-cart"
                                        className="auth-link-login text-white text-decoration-none"
                                        title="Shopping Cart"
                                    >
                                        <i className="bx bx-cart-alt" style={{ fontSize: "35px" }}></i>
                                        {cartCount > 0 && (
                                            <span className = "cart-count" 
                                                
                                            >
                                                {cartCount}
                                            </span>
                                        )}
                                    </Link>

                                    <div>
                                        <Link
                                            to="/user-profile"
                                            className="profile-link d-flex align-items-center"
                                        >
                                            <i
                                                id="UserProfileIcon"
                                                className="fa fa-user-circle text-white"
                                                style={{
                                                    fontSize: "40px",
                                                    borderRadius: "50%",
                                                    padding: "5px",
                                                    cursor: "pointer",
                                                }}
                                            ></i>
                                            <div className="user-details ms-2">
                                                <span className="user-name fw-semibold">{user?.USERNAME || "User Name"}</span>
                                            </div>
                                        </Link>

                                        <Tooltip
                                            placement="bottom"
                                            isOpen={tooltipOpen}
                                            target="UserProfileIcon"
                                            toggle={toggleTooltip}
                                        >
                                            My Profile
                                        </Tooltip>
                                    </div>

                                    <button
                                        onClick={() => setShowLogoutModal(true)}
                                        className="btn btn-sm btn-light fw-semibold logout-btn"
                                    >
                                        Logout
                                    </button>
                                </div>
                            ) : (
                                <div className="text-white fw-semibold d-flex align-items-center">
                                    <div className="d-none d-md-flex align-items-center">
                                        <Link
                                            to="/login"
                                            className="auth-link-login text-white text-decoration-none me-2"
                                        >
                                            Login
                                        </Link>
                                        <span className="mx-1">/</span>
                                        <Link
                                            to="/register"
                                            className="auth-link-register text-white text-decoration-none ms-2"
                                        >
                                            Register
                                        </Link>
                                    </div>

                                    <div className="d-md-none d-flex align-items-center">
                                        <Link
                                            to="/login"
                                            className="auth-link-login text-white text-decoration-none me-2"
                                            title="Login"
                                        >
                                            <i className="bx bx-log-in-circle" style={{ fontSize: "20px" }}></i>
                                        </Link>
                                        <span className="mx-1">/</span>
                                        <Link
                                            to="/register"
                                            className="auth-link-register text-white text-decoration-none ms-2"
                                            title="Register"
                                        >
                                            <i className="fa fa-address-card" style={{ fontSize: "20px" }}></i>
                                        </Link>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </nav>

                <div
                    className="navbar-layer-3 border-top border-bottom position-relative bg-light-new"
                    style={{ minHeight: "50px" }}
                >
                    <div className="container position-relative">
                        {/* Mobile Toggle */}
                        <button
                            className="navbar-toggler position-absolute d-md-none"
                            type="button"
                            onClick={toggleSubNav}
                            aria-expanded={isSubNavOpen}
                            aria-label="Toggle navigation"
                            style={{ left: "15px", top: "12px", border: "none" }}
                        >
                            <i className="bx bx-list-ul" style={{ fontSize: "25px" }}></i>
                        </button>

                        <div
                            className={`${isSubNavOpen ? "show" : ""} collapse navbar-collapse subnav-transition navbar-itemlink-text d-md-block`}
                            id="subNavbar"
                        >
                            <ul className="navbar-nav d-flex flex-column flex-md-row flex-wrap justify-content-center py-1">
                                {navItems.map((item) => (
                                    <li key={item.to} className="nav-item mx-2 my-1 my-md-0">
                                        <Link
                                            className={`nav-link text-center text-md-start ${location.pathname.startsWith(item.to) ? "active" : ""
                                                }`}
                                            to={item.to}
                                            onClick={closeSubNav}
                                        >
                                            {item.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </header>

            <div style={{ height: "120px" }}></div>

            {showLogoutModal && (
                <div
                    className="modal fade show d-block"
                    tabIndex="-1"
                    style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirm Logout</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowLogoutModal(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <p>Are you sure you want to log out?</p>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowLogoutModal(false)}
                                >
                                    No
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleLogout}
                                >
                                    Yes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
